module.exports = __webpack_public_path__ + "static/media/lscreen.fbd84b1e.png";